// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".part-thumbnail-preview-button[data-v-0fe4bff3]{align-items:center;background:transparent;border:0;cursor:pointer;display:flex;justify-content:center;padding:0}.part-thumbnail-preview-button[data-v-0fe4bff3]:focus-visible{outline:2px solid currentColor;outline-offset:2px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
